<div class="saas-sidebar-content" [class.saas-collapsed]="!sideNavStatus">
    <div class="saas-nav-groups">
        @for (header of menuList; track header.menuHeaderId) {
        <div class="saas-nav-group">
            <!-- Parent Category Header -->
            <div class="saas-group-header" [class.saas-group-active]="isParentActive(header)"
                (click)="toggleMenu(header.menuHeaderId)"
                [attr.title]="header.menuHeaderName">
                <div class="saas-group-title-wrap">
                    <i class="fa-solid saas-group-icon" [ngClass]="getParentIcon(header.menuHeaderName)"></i>
                    <span class="saas-group-title">{{header.menuHeaderName}}</span>
                </div>
                <i class="fa-solid saas-toggle-icon"
                    [class.fa-chevron-down]="openedMenuIds.includes(header.menuHeaderId)"
                    [class.fa-chevron-right]="!openedMenuIds.includes(header.menuHeaderId)">
                </i>
            </div>

            <!-- Submenu Items -->
            <ul class="saas-subnav-list" [class.saas-subnav-open]="openedMenuIds.includes(header.menuHeaderId)">
                @for (item of header.subMenuList; track item.menuId) {
                <li class="saas-nav-item"
                    [class.saas-item-active]="item.menuName == activeItem"
                    (click)="onMenuClick(item)"
                    [attr.title]="item.menuName">
                    <span class="saas-active-indicator" *ngIf="item.menuName == activeItem"></span>
                    <div class="saas-item-icon-wrap">
                        <i [class]="getMenuIcon(item.menuId)"></i>
                    </div>
                    <span class="saas-item-label">{{item.menuName}}</span>
                </li>
                }
            </ul>
        </div>
        }
    </div>

    <!-- Sidebar Bottom Footer -->
    @if (sideNavStatus) {
    <div class="saas-sidebar-footer">
        <div class="saas-version-pill">
            <span class="saas-dot-pulse"></span>
            <span>Aether v0.3.0</span>
        </div>
    </div>
    }
</div>
